<div class="row justify-content-center mt-2 mb-1">
  <div class="col-md-6">
    <ul id="progressbar">
      <li [ngClass]="{'active': step === 1}">{{'TEXT.DOC-ISSUE' | translate}}</li>
      <li [ngClass]="{'active': step === 2}">{{'TEXT.CREATE-DOC' | translate}}</li>
      <li [ngClass]="{'active': step === 3}">{{'TEXT.PREVIEW-DOC' | translate}}</li>
      <li [ngClass]="{'active': step === 4}">{{'TEXT.SUBMIT-DOC' | translate}}</li>
    </ul>
  </div>
</div>

<div *ngIf="step === 1">
  <div class="row justify-content-center">
    <div class="col">

      <h4 class="header">
        {{'TEXT.TITLE-IS-DOC' | translate}}
      </h4>

      <div class="rowFix type-parent text-center">
        <div class="col-md-6" *ngFor="let template of documentTypes">
          <div class="type-option" (click)="selectDocumentType(template)">
            <img src="../../../../assets/images/csv.png" alt="No Image" class="mr-4">
            {{ template.name }}
            <br>
            {{ template.nameEN }}
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div *ngIf="step === 2 || step === 3 || step === 4">
  <div [hidden]="step !== 2">
    <app-document-issue-form [buyerBranchID]="buyerBranchID" [document]="selectedDocumentType"
      (data)="previewPDF($event)">
    </app-document-issue-form>
  </div>

  <div *ngIf="step === 3 || step === 4">
    <div class="row justify-content-center">
      <div class="col">
        <h4 class="header">
          {{(step === 3 ? 'TEXT.PREVIEW-DOC' : 'TEXT.SUBMIT-DOC') | translate}}
        </h4>

        <div class="text-center">
          <ng-container *ngIf="!isLoading">
            <div [hidden]="pdfError && !pdfLoaded">
              <div class="mb-2">
                <a href="javascript:void(0)" class="text-secondary" (click)="prevPage()"
                  [ngStyle]="{'visibility': (pdfPage === 1) ? 'hidden' : 'visible'}">
                  <em class="fas fa-chevron-left m-r-5"></em>
                </a>
                <span class="text-bold" style="color: #02008a;">
                  {{ ('Page'|translate) + ' ' + pdfPage + ' ' + ('of'|translate) + ' ' + pdfPageLength }}
                </span>
                <a href="javascript:void(0)" class="text-secondary" (click)="nextPage()"
                  [ngStyle]="{'visibility': (pdfPage === pdfPageLength) ? 'hidden' : 'visible'}">
                  <em class="fas fa-chevron-right m-l-5"></em>
                </a>
              </div>

              <pdf-viewer [src]="pdf" [render-text]="true" [show-all]="false" [(page)]="pdfPage"
                (after-load-complete)="setPDF($event)">
              </pdf-viewer>
            </div>

            <span class="text-center text-danger text-bold" *ngIf="pdfError">{{ pdfError }}</span>
          </ng-container>

          <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
        </div>
      </div>
    </div>

    <div class="m-t-30 text-center" *ngIf="!isLoading && step === 3">
      <button class="btn btn-dv btn-clean btn-wide m-r-5" (click)="editDoc()">
        {{'NORMAL.EDIT' | translate}}
      </button>

      <button class="btn btn-dv btn-wide m-r-5" (click)="submitDoc()" *ngIf="!pdfError">
        {{'TEXT.SUBMIT' | translate}}
      </button>
    </div>

    <div class="m-t-30 text-center" *ngIf="!isLoading && step === 4">
      <button class="btn btn-dv btn-clean btn-wide m-r-5" (click)="startOver()">
        <em class="fas fa-redo m-r-5"></em>
        {{'ISSUE-TEXT.START-OVER' | translate}}
      </button>

      <button class="btn btn-dv btn-wide m-r-5" (click)="print()" *ngIf="!pdfError">
        <em class="fas fa-print m-r-5"></em>
        {{'ISSUE-TEXT.PRINT' | translate}}
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/document-issue.component.html